import { statuses, floorsList, paymentMethods, heightsList, units, roles, passwordRecoveryModal, changePasswordModal, editImage, profileForm, catalogSettingsModal, filters, measures, countries, login, autocomplete, alertDialog, noSelected, } from 'i18n/en.common';
export default {
    translation: {
        heightsList,
        main: {
            confirmationDialog: {
                accept: 'Accept',
                cancel: 'Decline',
            },
            controls: {
                top: {
                    projectList: 'Project list',
                    statisticsButton: 'Display statistics',
                    layersButton: 'Layers',
                    layers: {
                        metro: 'Metro',
                        places: 'Places',
                        districts: 'Districts',
                        emirates: {
                            AE: 'Emirates',
                            default: 'Regions',
                        },
                    },
                },
                middle: {
                    errorAddProject: 'The project can only be placed within the district.',
                    errorAddDistrict: {
                        AE: 'The district can only be placed within the emirate.',
                        default: 'The district can only be placed within the region.',
                    },
                    addNewObject: 'Add new object',
                    adminWidget: {
                        project: 'Project',
                        district: 'District',
                        emirate: {
                            AE: 'Emirate',
                            default: 'Region',
                        },
                        preLaunch: 'Pre-launch',
                    },
                },
                bottom: {
                    catalog: 'Catalog',
                },
            },
            metroStation: {
                line: '{{lineCode}} line',
                plannedStation: 'planned station',
                builtStation: 'built station',
                subtitle: 'Metro station',
            },
            searchKeywords: {
                title: 'Key words for search',
                add: 'Add',
                placeholder: 'Type the name',
                tooltip: 'Keywords used to find the project in search',
            },
            projectEdit: {
                create: 'Create project',
                edit: '',
                description: 'Description',
                save: 'Save',
                catalogPreview: 'Catalog preview',
                unitsStockUpdated: {
                    minutes_one: 'Units stock updated {{count}} minute ago',
                    minutes_few: 'Units stock updated {{count}} minutes ago',
                    minutes_many: 'Units stock updated {{count}} minutes ago',
                    minutes_other: 'Units stock updated {{count}} minutes ago',
                    hours_one: 'Units stock updated {{count}} hour ago',
                    hours_few: 'Units stock updated {{count}} hours ago',
                    hours_many: 'Units stock updated {{count}} hours ago',
                    hours_other: 'Units stock updated {{count}} hours ago',
                    days_one: 'Units stock updated {{count}} day ago',
                    days_few: 'Units stock updated {{count}} days ago',
                    days_many: 'Units stock updated {{count}} days ago',
                    days_other: 'Units stock updated {{count}} days ago',
                },
                deleteDialog: {
                    title: 'Delete project',
                    message: 'Is it really possible to delete it? \nIt will be impossible to restore, that`s all... End it!',
                },
                closeDialog: {
                    title: 'Exit project editing?',
                    message: 'You have not saved changes to the project. \n All unsaved data will be lost.',
                },
                tabs: {
                    information: 'Information',
                    configurations: 'Configurations',
                    transactions: 'Transactions',
                    typicalUnits: 'Typical units',
                    units: 'Units',
                    amenities: 'Amenities',
                    paymentPlans: 'Old payment plans',
                    paymentPlansNew: 'New payment plans',
                    documentsAndVideos: 'Documents & Videos',
                    '3d': '3D Models',
                },
                information: {
                    name: 'Name',
                    namePlaceholder: 'Name',
                    add: 'Add',
                    description: 'Description',
                    note: 'Project notes {{symbols}}/{{maxSymbols}} symbols',
                    notePlaceholder: 'Please enter your note',
                    developer: 'Developer',
                    seller: 'Seller',
                    developerPlaceholder: 'Not selected',
                    sellerPlaceholder: 'Not selected',
                    ownershipType: 'Type of ownership',
                    ownershipTypePlaceholder: 'Select',
                    postHandover: 'Post handover',
                    handover: 'Handover',
                    serviceCharge: {
                        TH: 'Sinking fund/Maintance fee',
                        default: 'Service charge',
                    },
                    minCommission: 'Commission From',
                    maxCommission: 'Commission To',
                    furnishing: 'Furnishing',
                    startOfSales: 'Start of sales',
                    eoi: 'EOI',
                    eoiTitle: {
                        MX: 'Reservation',
                        default: 'Expression of Interest (EOI)',
                    },
                    eoiFrom: 'From',
                    eoiTo: 'To',
                    eoiAmount: 'Amount',
                    eoiPercentage: 'Percentage',
                    eoiHint: 'Enter both values for a range, or one for a minimum or maximum. The same value in both fields sets an exact value.',
                    eoiNotProvided: 'Not provided',
                    eoiMinFrom: 'The eoi from field must be greater than 0.',
                    eoiMinTo: 'The eoi to field must be greater than 0.',
                    eoiRangeFrom: 'Must be less than or equal to {{max}}',
                    eoiRangeTo: 'Must be greater than or equal to {{min}}',
                    noc: 'Resale allowed after',
                    isPreLaunch: {
                        MX: 'Pre-sale',
                        default: 'Pre-launch',
                    },
                    preLaunchHint: {
                        MX: 'Reservation and start of sales apply only to pre-sale projects. Unchecking will delete both.',
                        default: 'EOI and start of sales apply only to pre-launch projects. Unchecking will delete both.',
                    },
                    isPublished: 'Published',
                    unpublishPriorityDialog: {
                        title: 'Project is being promoted',
                        text: 'This project is currently being promoted. If you unpublish it now, the promotion will stop and the spent budget won\'t be refunded. Continue?',
                        unpublish: 'Unpublish anyway',
                        cancel: 'Cancel',
                    },
                    isExclusive: 'Exclusive',
                    hasUnitsOnRequest: 'Availability upon request',
                    save: 'Save',
                    architecture: 'Architecture',
                    interior: 'Interior',
                    amenities: 'Amenities',
                    projectLocation: 'Project location (coordinates)',
                    projectLocationPlaceholder: 'Paste coordinates',
                    common: 'Common',
                    has3DModel: 'Has 3D model',
                    logoHint: 'Uses the Developer/Seller logo by default. Upload a custom one if you\'d like.',
                    customLogo: 'Custom logo',
                    logoReset: 'Reset',
                    logoSellerChangedNote: 'You have selected a different seller. If you no longer want a custom logo, please reset it',
                    logoDeveloperChangedNote: 'You have selected a different developer. If you no longer want a custom logo, please reset it',
                    addNewItems: {
                        title: 'Key words for search',
                        addText: 'Add',
                        placeholder: 'Type the name',
                        tooltip: 'Keywords used to find the project in search.',
                    },
                },
                configurations: {
                    config: 'Configuration',
                    add: 'Add new configuration',
                    deleteConfig: 'Delete configuration',
                    duplicate: 'Duplicate',
                    name: 'Configuration name',
                    description: 'Configuration description',
                    configType: 'Configuration type',
                    configTypePlaceholder: 'Configuration type',
                    attachConfig: 'New configuration',
                    updateConfig: 'Updated configuration',
                },
                transactions: {
                    title: 'DLD ID',
                    addText: 'Add',
                    placeholder: 'Type the number',
                    tooltip: 'DLD ID from the register.',
                },
                paymentPlans: {
                    plan: 'Plan',
                    add: 'Add new plan',
                    postHandover: 'Post handover',
                    deletePlan: 'Delete plan',
                    duplicate: 'Duplicate',
                    duplicateToOther: 'Duplicate into other project',
                    name: 'Plan name',
                    description: 'Plan description',
                    downPayment: 'Downpayment',
                    underConstruction: 'Total payments by the end of construction',
                    underConstructionPlaceholder: 'From 0% to 100%',
                    stepName: 'Name of payment step',
                    stepDescription: 'Description of payment step',
                    save: 'Save',
                    ...paymentMethods,
                    duplicateModal: {
                        title: 'Duplicate payment plan',
                        message: 'Select the destination to paste the payment plan duplicate',
                        apply: 'Apply',
                        inputPlaceholder: 'Select the projects',
                        dropdownInputPlaceholder: 'Search',
                    },
                    successModal: {
                        title: 'Successfully duplicated',
                        text: 'The {{planName}} successfully duplicated into following projects:',
                        ok: 'Ok',
                    },
                    errorModal: {
                        title: 'Error',
                        ok: 'Ok',
                    },
                },
                paymentPlansNew: {
                    methods: {
                        title: 'Payment methods',
                        credit_debit_card: 'Card',
                        cash: 'Cash',
                        crypto: 'Crypto',
                        bank_check: 'Master check',
                        bank_transfer: 'Bank transfer',
                    },
                    plans: {
                        title: 'Payment plans',
                        addPlan: 'New payment plan',
                        planItem: {
                            defaultName: 'Payment plans',
                            hasPostHandover: 'Has post handover',
                            noPostHandover: 'No post handover',
                            duplicate: 'Duplicate',
                            duplicateToOther: 'Duplicate into other project',
                            delete: 'Delete plan',
                            about: 'About plan',
                            switchLabel: 'Published',
                            titleEN: 'Plan name EN',
                            titleRU: 'Plan name RU',
                            placeholderEN: 'Name of plan',
                            placeholderRU: 'Название плана',
                            emptyFieldErr: 'Field can’t be empty',
                            toastWarning: 'Can’t copy unsaved payment plan, save it and try again!',
                            stage: {
                                addPayment: 'Add new step',
                                about: 'About payment',
                                when: 'When',
                                amount: 'Amount',
                                apply: 'Apply',
                                titleEN: 'Title EN',
                                titleRU: 'Title RU',
                                placeholderEN: 'Name of step',
                                placeholderRU: 'Название шага',
                                typeOfPayment: 'Type of payment',
                                trigger: 'Trigger',
                                switchRepeatPayments: 'Repeat payment',
                                refundable: 'Refundable',
                                value: 'Value',
                                typeAmount: 'Type amount',
                                intervalType: 'Interval type',
                                amountOfInterval: 'Amount of interval',
                                dateOfPayment: 'Date of payment',
                                constructionProgress: 'Construction progress',
                                repeatCount: 'How many times',
                                interval: 'Frequency',
                                frequency: 'Period',
                                dropdownEdit: 'Edit',
                                dropdownDuplicate: 'Duplicate',
                                dropdownDeleteStep: 'Delete step',
                                ready: 'ready',
                            },
                        },
                    },
                },
                amenities: {
                    save: 'Save',
                },
                documents: {
                    add: 'Add',
                    save: 'Save',
                    videos: {
                        title: 'Project videos',
                        documents: 'Documents',
                        add: 'Add',
                        vimeoLink: 'Vimeo link',
                        titleOfTheLink: 'Title of the link',
                        maxReached: 'Maximum 100 videos. Remove one before adding another.',
                    },
                },
                units: {
                    search: 'Unit search',
                    addTypical: 'Add new typical unit',
                    download: 'Download units',
                    uploadPlans: 'Upload plans',
                    updateRealUnitsCheckDateButton: 'Update the last updated date to today',
                    clearProjectStatisticButton: 'Clear statistics',
                    deleteSoldOutUnitButton: 'Delete Sold out unit',
                    updateTypicalUnitsDateTooltip: 'Update the last updated date to the current date',
                    notFilled: 'Not filled',
                    plan: 'Plan',
                    number: 'Number',
                    type: 'Type',
                    layout: 'Layout',
                    height: 'Height',
                    floor: 'Floor',
                    size: 'Size',
                    square: 'Size',
                    price: 'Price',
                    features: 'Features',
                    view: 'View',
                    views: 'View',
                    action: 'Action',
                    from: 'From',
                    to: 'To',
                    soldOut: 'Sold out',
                    soldOutShow: 'Show sold out',
                    soldOutHide: 'Hide sold out',
                    save: 'Save',
                    heightsList,
                    ...units,
                    unitEdit: {
                        selectLayout: 'Select layout',
                        layoutName: 'Layout name',
                        search: 'Search',
                        unitsList: 'Units list',
                        type: 'Type',
                        layout: 'Layout',
                        height: 'Height',
                        features: 'Features',
                        floor: 'Floor',
                        number: 'Number',
                        square: 'Square',
                        price: 'Price',
                        views: 'Views',
                        save: 'Save',
                        apply: 'Apply',
                        renderersShow: 'All units',
                        renderersHide: 'Without layouts',
                        uploadError: 'You cannot upload more than 10 files at a time.',
                        deleteDialog: {
                            title: 'Delete Unit',
                            message: 'Are you sure you want to delete the unit? \nIt will be completely removed from the system after saving the project! \n If you want to mark the unit as Sold Out, please upload a new CSV file.', // eslint-disable-line
                        },
                        noChanges: {
                            title: 'No changes were detected in the file',
                            footnote: 'Kindly update it before submitting.',
                        },
                    },
                    updateRealUnitsCheckDateDialog: {
                        title: 'Refresh the last updated date',
                        text: 'Are you sure you want to change the date to today?',
                        successText: 'Update complete!',
                        failText: 'Update fail: {{json}}',
                        cancel: 'Cancel',
                        update: 'Update',
                    },
                    clearStatisticDialog: {
                        title: 'Project statistics',
                        text: 'Are you sure you want to clear statistics for whole project?',
                        successText: 'The statistics was successfully cleared',
                        failText: 'Clear fail: {{json}}',
                        clear: 'Clear',
                    },
                    updateTypicalUnitsCheckDateDialog: {
                        title: 'Refresh the last updated date',
                        text: 'Are you sure you want to change the date to today?',
                        successText: 'Update complete!',
                        failText: 'Update fail: {{json}}',
                        cancel: 'Cancel',
                        update: 'Update',
                    },
                    deleteAllPlansDialog: {
                        title: 'Remove all plans?',
                        description: 'Are you sure you want to remove plans from all units in this project? (except resale-units)',
                        tryAgainBtn: 'Try again',
                    },
                    deleteSelected: 'Delete selected',
                    deleteSelectedUnitsDialog: {
                        title: 'Delete selected units',
                        description: 'Are you sure you want to delete selected units?',
                        cancel: 'Cancel',
                        delete: 'Delete',
                    },
                    deleteSoldOutUnitDialog: {
                        title: 'Delete Sold out unit',
                        text: 'Type the number of the unit to delete it',
                        inputPlaceholder: 'Unit number',
                        deleteButton: 'Delete',
                        successText: 'The unit was successfully deleted',
                        failText: 'Delete fail: {{message}}',
                        ok: 'Ok',
                    },
                    importSettingsModal: {
                        title: 'Set import currency and area unit',
                        projectLabel: 'Project:',
                        noticeTitle: 'Permanent import settings',
                        noticeText: 'These settings will be applied to all seller units in Sunti Residence and all future imports.' +
                            ' Prices and areas will be stored exactly as provided in the files, without conversion. These settings cannot be changed later in the administration interface.',
                        currencyPlaceholder: 'Select currency',
                        currencyTitle: 'Currency',
                        areaUnitPlaceholder: 'Select area unit',
                        areaUnitTitle: 'Area measurement unit',
                        cancel: 'Cancel import',
                        submit: 'Set settings and continue',
                    },
                },
                amenitiesEditFailTitle: 'Error updating amenities',
                models3d: {
                    add: 'New building',
                    units: 'units',
                    edit: 'Edit building',
                    delete: 'Delete building',
                    published: 'Published',
                },
                catalogPreviewModal: {
                    title: 'Project preview',
                    bodyText: 'Opens in a new tab and shows how the project will look in the catalog. Preview reflects saved changes only.',
                    openPreview: 'Open in a new tab',
                    error: 'Error',
                },
            },
            emirateEdit: {
                name: 'Name',
                newEmirate: {
                    AE: 'New emirate',
                    default: 'New region',
                },
                aboutEmirate: {
                    AE: 'About emirate',
                    default: 'About region',
                },
                emirateName: {
                    AE: 'Emirate name',
                    default: 'Region name',
                },
                selectColor: 'Select color',
                deleteConfirmationModal: {
                    title: {
                        AE: 'Delete emirate?',
                        default: 'Delete region?',
                    },
                    description: {
                        AE: 'Are you sure you want to delete the emirate?',
                        default: 'Are you sure you want to delete the region?',
                    },
                },
                create: 'Create',
                save: 'Save',
                location: 'Location',
                add: 'Add',
            },
            districtEdit: {
                createDistrict: 'Create district',
                editDistrict: 'Edit district',
                newDistrict: 'New District',
                photos: 'Photos',
                averagePrice: 'Average price',
                aboutDistrict: 'About district',
                districtName: 'District name',
                name: 'Name',
                description: 'Description',
                selectColor: 'Select color',
                deleteConfirmationModal: {
                    title: 'Delete district?',
                    description: 'Are you sure you want to delete the district?',
                },
                deleteBlockedNotification: {
                    description: 'The district has projects. Delete the projects first',
                },
                create: 'Create',
                save: 'Save',
                addNewItems: {
                    title: 'Key words for search',
                    addText: 'Add',
                    placeholder: 'Type the name',
                    tooltip: 'Keywords used to find the district in search',
                },
                location: 'Location',
                add: 'Add',
            },
            addNewItems: {
                title: 'Key words for search',
                addText: 'Add',
                placeholder: 'Type the name',
                tooltip: 'Keywords used to find the project in search',
            },
            districtView: {
                description: 'Description',
                descriptionHide: 'Hide',
                descriptionShow: 'Show',
                developers: 'Developers',
                places: 'Places',
                projectsCount_one: '{{count}} project',
                projectsCount_two: '{{count}} projects',
                projectsCount_few: '{{count}} projects',
                projectsCount_many: '{{count}} projects',
                projectsCount_other: '{{count}} projects',
                from: 'From',
            },
            projectView: {
                tags: {
                    developerStock: 'DEVELOPER STOCK',
                    resale: 'RESALE',
                    preLaunch: 'PRE-LAUNCH',
                    soldOut: 'SOLD OUT',
                },
                description: 'Description',
                descriptionHide: 'Hide',
                descriptionShow: 'Show',
                floor: 'floor',
                resale: 'Resale',
                distress: 'Distress',
                priceWithCommission: 'Price with commission',
                priceWithoutCommission: 'Price without commission',
                unitFeature: 'Unit Feature',
                unitView: 'View from the window',
                currencyUpdatedDaily: 'updated daily',
                unitContactsAria: 'Unit sales contacts',
                unitContactsModalTitle: 'Contacts',
                unitContactsModalOk: 'Ok',
                fullUnitsList: 'Full units list',
                addToCatalog: 'Project to catalog',
                unitsOnRequestHint: {
                    start: 'Some units from the developer’s stock are available upon ',
                    link: 'manager’s',
                    end: ' request.',
                },
                unitsOnRequestBlockTitle: 'Units upon request',
                unitsOnRequestBlockTitleSome: 'Some developer units upon request',
                unitsOnRequestBlockDescription: 'Contact the manager to get all the details about units in this project.',
                tabs: {
                    information: 'Information',
                    amenities: 'Amenities',
                    paymentPlans: 'Payment plans',
                    units: 'Units',
                    documentsAndVideos: 'Documents & Videos',
                    seller: 'Seller',
                    placesNearby: 'Places nearby',
                    transactions: 'Transactions',
                },
                paymentMethods,
                information: {
                    developer: 'Developer',
                    district: 'District',
                    price: 'Price',
                    pricePerSquare: 'Price per',
                    size: 'Size',
                    postHandover: 'Post handover',
                    handover: {
                        title: 'Completion',
                        ready: 'Ready',
                    },
                    ownershipType: {
                        title: 'Type of ownership',
                        leasehold: 'Leasehold',
                        freehold: 'Freehold',
                    },
                    unitType: 'Unit type',
                    serviceCharge: {
                        TH: 'Sinking fund/Maintance fee',
                        default: 'Service charge',
                    },
                    furnishing: 'Furnishing',
                    startOfSales: 'Start of sales',
                    eoi: {
                        title: {
                            MX: 'Reservation',
                            default: 'Expression of Interest (EOI)',
                        },
                        from: 'From',
                        upTo: 'Up to',
                        hint: {
                            MX: 'The final reservation amount depends on the selected unit and the seller\'s terms.',
                            default: 'The final EOI amount depends on the selected unit and the seller\'s terms.',
                        },
                    },
                    noc: 'Resale allowed after',
                    projectConfigurations: 'Project configurations',
                    managersContacts: 'Developer contacts',
                    managersName: 'Name',
                    managersPhone: 'Phone',
                    hide: 'Hide',
                    show: 'Show',
                    yes: 'Yes',
                    no: 'No',
                },
                units: {
                    ...units,
                    from: 'from',
                },
                paymentPlans: {
                    postHandover: 'Post Handover',
                    noPostHandover: 'No Post Handover',
                    payment_one: '{{count}} payment',
                    payment_few: '{{count}} payments',
                    payment_many: '{{count}} payments',
                    payment_other: '{{count}} payments',
                    times_one: '({{count}} time every {{intervalType}})',
                    times_few: '({{count}} times every {{intervalType}})',
                    times_many: '({{count}} times every {{intervalType}})',
                    times_other: '({{count}} times every {{intervalType}})',
                    type_day_one: '{{count}} day',
                    type_day_few: '{{count}} days',
                    type_day_many: '{{count}} days',
                    type_day_other: '{{count}} days',
                    type_week_one: '{{count}} week',
                    type_week_few: '{{count}} weeks',
                    type_week_many: '{{count}} weeks',
                    type_week_other: '{{count}} weeks',
                    type_month_one: '{{count}} month',
                    type_month_few: '{{count}} months',
                    type_month_many: '{{count}} months',
                    type_month_other: '{{count}} months',
                    type_year_one: '{{count}} year',
                    type_year_few: '{{count}} years',
                    type_year_many: '{{count}} years',
                    type_year_other: '{{count}} years',
                    ready: 'ready',
                },
                seller: {
                    salesManagers: 'Sales managers',
                    salesManagersDescription: 'Contacts',
                    resaleContactsHint: 'For resale unit contacts, please refer to the unit card.',
                    commission: 'Commission',
                    commissionDescription: 'Applicable commission fee',
                    commissionItemDescription: 'Rate for deals',
                    address: 'Office location',
                    descriptionShow: 'Show',
                    descriptionHide: 'Hide',
                    clipboard: 'Copied!',
                },
                floorsList,
                heightsList,
                placesNearby: {
                    meters: 'meters',
                },
                transactions: {
                    empty: {
                        header: 'No statistics yet',
                        subheader: 'We are working on it',
                        noData: 'No data',
                        noDataChart: 'No data. Please modify filters to see statistics.',
                    },
                    tab: {
                        header: 'All time summary',
                        subheader: 'Tap the button below to see detailed information.',
                        price: 'Median price',
                        priceRatio: 'Median price/{{square}}',
                        transactions: 'Transactions',
                        modalButton: 'Full information',
                    },
                    modal: {
                        table: {
                            saleType: 'Sale type',
                            type: 'Type',
                            layouts: 'Layouts',
                            size: 'Size',
                            price: 'Price',
                            salesDate: 'Sales Date',
                            resale: 'Resale',
                            firstSale: 'First sale',
                        },
                        filters: {
                            period: 'Period',
                            interval: 'Interval',
                            periodFilter: 'Year to date',
                            dateFrom: "Date from",
                            dateTo: "Date to",
                            selectLayout: 'All layouts',
                            selectType: 'All types',
                            saleType: 'All sale types',
                            allTime: 'All time',
                            resale: 'Resale',
                            firstSale: 'First sale',
                            filtersValues: {
                                periods: {
                                    'week': 'Last week',
                                    'month': 'Last month',
                                    '3months': 'Last 3 months',
                                    '6months': 'Last 6 months',
                                    'year': 'Year to date',
                                    'allTime': 'All time',
                                    'range': 'Custom range',
                                },
                                intervals: {
                                    'day': 'Day',
                                    'week': 'Week',
                                    'month': 'Month',
                                    'quarter': 'Quarter',
                                    'year': 'Year',
                                },
                                layouts: {
                                    'all': 'All layouts',
                                    'Studio': 'Studio',
                                    'Office': 'Office',
                                    'Retail': 'Retail',
                                    '1': '1 bedroom',
                                    '2': '2 bedrooms',
                                    '3': '3 bedrooms',
                                    '4': '4 bedrooms',
                                    '5': '5 bedrooms',
                                    'PLUS_6': '6+ bedrooms',
                                },
                                types: {
                                    'all': 'All types',
                                    '213': 'Apartment',
                                    '215': 'Villa',
                                    '217': 'Plot',
                                    '218': 'Commerce',
                                },
                                saleTypes: {
                                    'all': 'All sale types',
                                    '0': 'First sale',
                                    '1': 'Resale',
                                },
                            },
                        },
                    },
                },
            },
            filters: {
                byLocation: {
                    title: 'Location',
                    reset: 'Reset location',
                },
                byCompany: {
                    title: 'Company',
                    reset: 'Reset company',
                },
                other: {
                    title: 'Main filters',
                    reset: 'Reset filters',
                },
            },
            fullUnitsList: {
                ...units,
                floorPlan: 'Plan',
                number: 'Number',
                type: 'Type',
                layout: 'Layouts',
                unitHeight: 'Unit height',
                floor: 'Floor',
                size: 'Size',
                price: 'Price',
                view: 'View',
                action: 'Action',
                searchPlaceholder: 'Unit search',
                pricePerSquare: 'Price per',
                priceWithCommission: 'Price with commission',
                priceWithoutCommission: 'Price without commission',
                distress: 'Distress',
                floorsList,
                heightsList,
                unitsOnRequestHint: {
                    start: 'Some units from the developer’s stock are available upon ',
                    link: 'manager’s',
                    end: ' request.',
                },
            },
            blockCompanyGap: {
                text_one: ' {{count}} day left until the end of your current subscription. To extend access, contact your manager.',
                text_few: ' {{count}} days left until the end of your current subscription. To extend access, contact your manager.',
                text_many: ' {{count}} days left until the end of your current subscription. To extend access, contact your manager.',
                text_other: ' {{count}} days left until the end of your current subscription. To extend access, contact your manager.',
            },
            statistics: {
                tooltipText: 'Since the previous update',
                tooltipPreLaunchText: 'Pre-launch price',
                chartPreLaunchPointText: 'Pre-launch',
            },
            leftPanel: {
                project: 'Project',
                district: 'District',
                region: 'Region',
                place: 'Place',
                filter: 'Filters',
                '3D': '3D',
            },
        },
        personal: {
            companies: {
                title: 'Companies',
                add: 'Add company',
                tag_one: '{{count}} company',
                tag_few: '{{count}} companies',
                tag_many: '{{count}} companies',
                tag_other: '{{count}} companies',
                broker: 'Broker',
                developer: 'Developer',
                agency: 'Agency',
                blocked: 'Blocked',
                active: 'Active',
                notAssigned: 'Not assigned',
                all: 'All',
                searchPlaceholder: 'Search',
                typePlaceholder: 'Type',
                contentManagerPlaceholder: 'Content manager',
                salesManagerPlaceholder: 'Sales manager',
                statusPlaceholder: 'Status',
                titles: {
                    status: 'Status',
                    logo: 'Logo',
                    name: 'Name',
                    type: 'Type',
                    employees: 'Employees',
                    blocking: 'Blocking',
                    contentManager: 'Content',
                    salesManager: 'Sales',
                    change: 'Change',
                },
                editCompany: {
                    company: 'Company',
                    type: 'Type of company',
                    agent: 'Agent',
                    developer: 'Developer',
                    basicInformation: {
                        title: 'Basic information',
                        name: {
                            title: 'Company name',
                            placeholder: 'Name',
                        },
                        description: {
                            title: 'Description {{chars}}/{{maxChars}}',
                            placeholder: 'Maximum 500 characters',
                        },
                        maxUsersCount: {
                            title: 'Maximum number of users',
                            placeholder: 'Up to 100',
                        },
                        site: {
                            title: 'Site',
                            placeholder: 'Insert link',
                        },
                        address: {
                            broker: {
                                title: 'Company address',
                                placeholder: 'Insert address',
                            },
                            developer: {
                                title: 'Sales office address',
                                placeholder: 'Insert address',
                            },
                        },
                    },
                    blocking: {
                        title: 'Blocking',
                        expiredAt: {
                            title: 'Blocking date',
                            hint: 'The blocking will occur at 00:00 UTC on the specified date',
                        },
                    },
                    resale: {
                        title: 'Resale access',
                        maxUnits: {
                            title: 'Number of resale units',
                            placeholder: '0',
                        },
                    },
                    contacts: {
                        title: 'Sales office contacts',
                        name: {
                            title: 'Manager name',
                            placeholder: 'John Smith',
                        },
                        phone: {
                            title: 'Phone',
                        },
                    },
                    responsible: {
                        title: 'Responsible employees',
                        searchPlaceholder: 'Search',
                        notAssigned: 'Not assigned',
                        content: {
                            title: 'Content manager',
                            placeholder: 'Select a manager',
                        },
                        sales: {
                            title: 'Sales manager',
                            placeholder: 'Select a manager',
                        },
                    },
                    create: 'Create',
                    save: 'Save',
                    analyticsMetrics: {
                        title: 'Access to metrics service',
                    },
                    addNewItems: {
                        title: 'Key words for search',
                        addText: 'Add',
                        placeholder: 'Type the name',
                        tooltip: 'Keywords used to find the project in search',
                    },
                    countries: {
                        title: 'Available countries',
                        placeholder: 'Select countries',
                    },
                    deleteDialog: {
                        title: 'Delete company?',
                        text: 'The company will be deleted and will be difficult to restore.',
                        cancel: 'Cancel',
                        confirm: 'Confirm',
                    },
                    deleteErrorDialog: {
                        title: 'The company cannot be deleted',
                        ok: 'Ok',
                    },
                },
            },
            employees: {
                count_one: '{{count}} employee',
                count_few: '{{count}} employees',
                count_many: '{{count}} employees',
                count_other: '{{count}} employees',
                createUser: 'Create user',
                inviteUser: 'Invite user',
                delete: 'Delete',
                edit: 'Edit',
                changePassword: 'Change password',
                companySelectionRequired: 'Company selection required',
                employees: 'Employees',
                requests: 'Requests',
                reject: 'Reject',
                approve: 'Approve',
                role: 'Role',
                userSearch: 'User search',
                editEmployee: {
                    broker: 'User',
                    head_of_sales_department: 'Administrator',
                    admin: 'Supreme administrator',
                    additionalContacts: 'Additional contacts',
                    user: 'User',
                    name: 'Name',
                    namePlaceholder: 'John Smit',
                    email: 'Email',
                    emailPlaceholder: 'john@company.com',
                    phone: 'Phone',
                    password: 'Password',
                    role: 'Role',
                    create: 'Create',
                    edit: 'Edit',
                    add: 'Add',
                    tg: 'Telegram',
                    whatsapp: 'WhatsApp',
                    instagram: 'Instagram',
                    roles,
                    requiredField: 'The phone field is required.',
                    hint: 'The new password must be at least 8 characters long and include at least one uppercase and lowercase letter, number, and symbol.',
                    mainInfo: 'Main information',
                    passwordInfo: 'Create new password',
                },
                changeEmployeePassword: {
                    header: 'Change password',
                    description: 'The new password must be at least 8 characters long and include at least one uppercase and lowercase letter, number, and symbol.',
                    uppercaseAndLowercaseLetterTitle: 'The password must contain at least one lowercase and one uppercase letter.',
                    oneDigitTitle: 'The password must contain at least one digit.',
                    specialSymbolTitle: 'The password must contain at least one special character.',
                    minimumLengthTitle: 'The password length must be at least 8 characters.',
                    newPasswordPlaceholder: 'New password',
                    confirmedNewPasswordPlaceholder: 'Confirm new password',
                    shortPasswordError: 'The password must be at least 8 characters.',
                    submitButton: 'Edit password',
                },
                roles: {
                    all: 'All',
                    broker: 'User',
                    head_of_sales_department: 'Administrator',
                    admin: 'Supreme administrator',
                },
                inviteDropdown: {
                    share: 'Share invite link',
                    downloadQR: 'Download QR',
                    copyLink: 'Copy link',
                    copyLinkSuccess: 'Link copied',
                    refreshLink: 'Refresh link',
                },
                headers: {
                    photo: 'Photo',
                    name: 'Name',
                    role: 'Role',
                    email: 'Email',
                    phone: 'Phone',
                    active: 'Active',
                    actions: 'Actions',
                },
                approveConfirmation: {
                    header: 'Approve request?',
                    description: 'Are you sure you want to approve the request from:\n{{name}}?',
                    accept: 'Yes',
                    cancel: 'No',
                },
                approveError: {
                    header: 'Something went wrong',
                    description: 'An error occurred while processing your request. Please contact support',
                },
                rejectConfirmation: {
                    header: 'Deny request?',
                    description: 'Are you sure you want to reject the request from:\n{{name}}?',
                    accept: 'Yes',
                    cancel: 'No',
                },
                createEmployeeDialog: {
                    title: 'Creating a user',
                    somethingWentWrong: 'Something went wrong',
                },
            },
            catalog: {
                catalog: 'Catalog',
                clear: 'Clear',
                preview: 'Preview',
                settings: 'Settings',
                create: 'Create catalog',
                created: 'Catalog created',
                createdError: {
                    title: 'Catalog created error',
                    description: 'Please try again or try again later',
                },
                modal: {
                    title: 'Specify directory options',
                    layoutImage: 'With layouts',
                    layoutTable: 'Table',
                    darkTheme: 'Dark theme',
                    lightTheme: 'Light theme',
                    withMap: 'Project location with description of the area',
                    hideUnitsNumbers: 'Hide units numbers',
                    withDeveloper: 'Description of the developer',
                    save: 'Save',
                    cancel: 'Cancel',
                },
                empty: {
                    title: 'Your catalog is empty',
                    description: 'Add projects or objects from the map to start working with your catalog',
                    button: 'Go to map',
                },
                project: 'Project',
                number: 'Number',
                type: 'Type',
                layout: 'Layout',
                height: 'Height',
                floor: 'Floor',
                size: 'Square',
                pricePerSquare: 'Price per',
                price: 'Price',
                action: 'Action',
                heightsList,
                ...floorsList,
                yes: 'yes',
                no: 'No',
                noDataTitle: 'There is nothing in the catalog',
                noDataDescription: 'Add units to the catalog by selecting them on the map',
            },
            files: {
                files: 'Files',
                addFolder: 'Add folder',
                addFile: 'Add file',
            },
            menu: {
                profile: 'My profile',
                places: 'Places',
                amenities: 'Amenities',
                companies: 'Companies',
                employees: 'Employees',
                files: 'Files',
                catalog: 'Catalog',
                resale: 'Resale',
                toTheMap: 'To the map',
            },
            profile: {
                changePassword: 'Change password',
                logout: 'Log out',
                cancel: 'Cancel',
                save: 'Save',
            },
            amenities: {
                title: 'Amenities',
                actions: {
                    createAmenity: 'Create new Amenity',
                    createType: 'Create new Type',
                    loadAmenities: 'Download Amenities as CSV',
                    loadTypes: 'Download Types as CSV',
                },
                filters: {
                    typeSearch: 'Search for type',
                    amenitiesSearch: 'Search for amenity',
                    types: 'Types',
                },
                empty: {
                    title: 'No results found',
                    description: 'Try using different search options',
                    clean: 'Clean',
                },
                list: {
                    title: 'Amenities',
                    count_one: '{{count}} item',
                    count_few: '{{count}} items',
                    count_many: '{{count}} items',
                    count_other: '{{count}} items',
                    icon: 'Icon',
                    name: 'Name',
                    category: 'Category',
                    edit: 'Edit',
                    editAmenity: 'Edit amenity',
                    deleteAmenity: 'Delete amenity',
                    deleteDialog: {
                        title: 'Delete amenity',
                        message: 'Are you sure you want to delete the amenity?',
                        cancel: 'Cancel',
                        delete: 'Delete',
                    },
                },
                types: {
                    title: 'Types',
                    count_one: '{{count}} category',
                    count_few: '{{count}} categories',
                    count_many: '{{count}} categories',
                    count_other: '{{count}} categories',
                    icon: 'Icon',
                    name: 'Name',
                    amenitiesCount: 'Amount of amenities',
                    edit: 'Edit',
                    editType: 'Edit type',
                    deleteType: 'Delete type',
                    deleteDialog: {
                        title: 'Delete type',
                        message: 'Are you sure you want to delete this type?',
                        cancel: 'Cancel',
                        delete: 'Delete',
                    },
                    deleteBlockedNotification: {
                        description: 'Unable to delete the type because it contains amenities',
                    },
                },
                editTypeModal: {
                    editTitle: 'Edit type',
                    createTitle: 'New type',
                    subtitle: 'Make sure the type name is unique and doesn\'t match any existing ones.',
                    nameEnTitle: 'Name of type in English',
                    nameRuTitle: 'Name of type in Russian',
                    namePlaceholder: 'Name of type',
                    save: 'Save',
                },
                editAmenityModal: {
                    editTitle: 'Edit amenity',
                    createTitle: 'New amenity',
                    nameSectionTitle: 'Name',
                    nameEnTitle: 'Name of amenity in English',
                    nameRuTitle: 'Name of amenity in Russian',
                    namePlaceholder: 'Name of amenity',
                    typeTitle: 'Type',
                    typePlaceholder: 'No type',
                    save: 'Save',
                },
            },
            places: {
                title: 'Places',
                actions: {
                    createPlace: 'Create new Place',
                    createType: 'Create new Type',
                    loadPlaces: 'Download Places as CSV',
                    loadTypes: 'Download Types as CSV',
                },
                filters: {
                    typeSearch: 'Search for type',
                    placesSearch: 'Search for places',
                    emirates: {
                        AE: 'Emirates',
                        default: 'Regions',
                    },
                    districts: 'Districts',
                    categories: 'Categories',
                },
                list: {
                    title: 'Places',
                    count_one: '{{count}} place',
                    count_few: '{{count}} places',
                    count_many: '{{count}} places',
                    count_other: '{{count}} places',
                    icon: 'Icon',
                    name: 'Name',
                    edit: 'Edit',
                    emirates: {
                        AE: 'Emirates',
                        default: 'Regions',
                    },
                    districts: 'Districts',
                    categories: 'Categories',
                    deleteDialog: {
                        title: 'Delete sight',
                        message: 'Are you sure you want to delete the sight?',
                        cancel: 'Cancel',
                        delete: 'Delete',
                    },
                    editPlace: 'Edit Place',
                    deletePlace: 'Delete Place',
                },
                editTypeModal: {
                    subtitle: 'Make sure the category name is unique and does not match any existing ones.',
                    nameSectionTitle: 'Name',
                    nameEnTitle: 'Name of sight in English',
                    nameRuTitle: 'Name of sight in Russian',
                    namePlaceholder: 'Name of sight',
                    importantLabel: 'Important category',
                    editTitle: 'Edit type',
                    createTitle: 'New type',
                    save: 'Save',
                    hint: 'Important places (malls, schools, museums) appear at the top of the list; less important ones (like a bus stop) stay at the bottom.',
                },
                types: {
                    title: 'Types',
                    count_one: '{{count}} type',
                    count_few: '{{count}} types',
                    count_many: '{{count}} types',
                    count_other: '{{count}} types',
                    icon: 'Icon',
                    name: 'Name',
                    placesCount: 'Amount of places',
                    edit: 'Edit',
                    editType: 'Edit type',
                    deleteType: 'Delete type',
                    deleteDialog: {
                        title: 'Delete category',
                        message: 'Any places that only belong to this category will show up uncategorized. Just add a new one manually if needed.',
                        cancel: 'Cancel',
                        delete: 'Delete',
                    },
                },
                editCreatePlaceModal: {
                    createTitle: 'New place',
                    editTitle: 'Edit place',
                    save: 'Save',
                    locationSectionTitle: 'Location',
                    locationPlaceholder: 'Paste location or tap on map to select',
                    nameSectionTitle: 'Name',
                    namePlaceholder: 'Name of sight',
                    descriptionSectionTitle: 'Description',
                    descriptionPlaceholder: 'Maximum 500 symbols',
                    categoriesSectionTitle: 'Categories',
                    newCategory: 'New category',
                    categoriesPlaceholder: 'No category',
                    photosSectionTitle: 'Photos',
                    uploadLabel: 'Upload file',
                    categoriesDescription: 'Select the icon which will be visible fo users',
                    nameEnTitle: 'Name of sight in English',
                    nameRuTitle: 'Name of sight in Russian',
                },
            },
            resale: {
                searchPlaceholder: 'Unit search',
                add: 'Add',
                statuses,
                status: 'Status',
                project: 'Project',
                number: 'Number',
                price: 'Price',
                square: 'Area',
                floor: 'Floor',
                type: 'Type',
                layout: 'Layout',
                edit: 'Edit',
                district: 'District',
                assignee: 'Assignee',
                sold_out: 'Sold out',
                downloadUnits: 'Download units',
                ...units,
                floorsList,
                addUnitModal: {
                    add: 'Add unit',
                    edit: 'Edit unit',
                    tabs: {
                        commonData: {
                            name: 'Common data',
                            unitData: 'Unit data',
                            project: 'Project',
                            projectPlaceholder: 'Select project',
                            searchProjectInputPlaceholder: 'Name of project',
                            projectNoOptionsText: 'If the project you need is not in the list, contact support via chat.',
                            unitNumber: 'Unit number',
                            unitNumberPlaceholder: 'Enter number',
                        },
                        unitDetails: {
                            name: 'Unit details',
                            unitSpecification: 'Unit specification',
                            square: 'Area in ft²',
                            squareShort: 'Area',
                            squarePlaceholder: '0 ft²',
                            amountPlaceholder: '0',
                            unitType: 'Unit type',
                            unitTypePlaceholder: 'Select',
                            rooms: 'Layout',
                            roomsPlaceholder: 'Select',
                            height: 'Height',
                            heightPlaceholder: 'Select',
                            internalFloor: 'Approximate floor',
                            internalFloorPlaceholder: 'Select',
                            floor: 'Floor',
                            floorPlaceholder: 'Floor number',
                            view: 'View',
                            viewPlaceholder: 'List separated by commas',
                            unitFeatures: 'Unit features',
                            unitFeaturesPlaceholder: 'Select unit features',
                            priceWithCommission: 'Price with commission',
                            price: 'Price in AED',
                            priceShort: 'Price',
                            pricePlaceholder: '0 AED',
                            documents: 'Documents',
                            documentTemplate: 'Listing validation form',
                            firstDocumentPlaceholder: 'Oqood/Tittle deed/SPA',
                            secondDocumentPlaceholder: 'Validation form (Contract A)',
                            duplicateFilesError: 'The files must be different',
                            layouts: 'Layouts',
                            layoutsPlaceholder: 'Select images',
                            attachLayoutsHint: 'It is required to upload the unit layout(s). Uploading project renders or other photos is not permitted.',
                            distress: 'Distress',
                            distressHint: 'Distress - price of the unit must be lower or the same as the Original price',
                            markAsDistress: 'Mark as distress',
                            floorsList,
                            heightsList,
                        },
                    },
                    button: {
                        next: 'Next',
                        create: 'Create',
                        toModeration: 'To moderation',
                        save: 'Save',
                    },
                    statuses: {
                        title: 'Status',
                        ...statuses,
                    },
                },
                changeStatusUnitModal: {
                    status: 'Status',
                    distress: 'Distress',
                    project: 'Project',
                    unitNumber: 'Unit number',
                    square: 'Area',
                    floor: 'Floor',
                    unitType: 'Unit type',
                    rooms: 'Rooms count',
                    height: 'Height',
                    price: 'Price',
                    firstDocument: 'Oqood/Title deed',
                    secondDocument: 'Validation form',
                    layouts: 'Layouts',
                    declineReason: 'Decline reason',
                    deleteConfirmation: 'Are you sure you want to delete the unit?',
                    soldOutConfirmation: "Are you sure you want to change the unit's status?",
                    view: 'View',
                    features: 'Unit features',
                    floorsList,
                    heightsList,
                    statuses,
                    buttons: {
                        decline: 'Decline',
                        publish: 'Publish',
                        delete: 'Delete',
                        soldOut: 'Sold out',
                        unpublish: 'Unpublish',
                    },
                },
                declineReasonModal: {
                    header: 'Decline reason',
                    close: 'Close',
                },
                unitsLimitReachedModal: {
                    header: 'Limit has been reached',
                    text_one: 'You have reached the limit of {{count}} unit. Please contact your administrator.',
                    text_few: 'You have reached the limit of {{count}} units. Please contact your administrator.',
                    text_many: 'You have reached the limit of {{count}} units. Please contact your administrator.',
                    text_other: 'You have reached the limit of {{count}} units. Please contact your administrator.',
                    close: 'Close',
                },
                downloadResaleUnitModal: {
                    title: 'Download units',
                    submit: 'Download Excel sheet',
                    message: 'Choose the properties to show in the sheet.',
                    successMessage: 'The table has been downloaded successfully! Please check your browser\'s downloads page.',
                    ok: 'Ok',
                    columns: {
                        project: 'Project',
                        price: 'Price AED',
                        area: 'Area ft²',
                        districtName: 'District',
                        unitType: 'Type',
                        unitLevel: 'Floor',
                        unitFeature: 'Unit Features',
                        unitNumber: 'Unit number',
                        unitStatus: 'Status',
                        unitLayout: 'Layout',
                        assignUserName: 'Assignee',
                    },
                },
            },
        },
        login,
        resetPassword: {
            passwordReset: {
                header: 'Password recovery',
                body: 'Create a new password. It must be at least 8 characters long and include at least one uppercase and lowercase letter, number, and symbol.',
                uppercaseAndLowercaseLetterTitle: 'The password must contain at least one lowercase and one uppercase letter.',
                oneDigitTitle: 'The password must contain at least one digit.',
                specialSymbolTitle: 'The password must contain at least one special character.',
                minimumLengthTitle: 'The password length must be at least 8 characters.',
                password: 'New password',
                passwordConfirmation: 'Confirm your new password',
            },
            passwordSubmited: {
                header: 'You now have a new password!',
                body: 'The new password has been successfully created and you can now use it to log into Geniemap.',
            },
            createPassword: 'Save password',
            ok: 'Ok',
        },
        registration: {
            invalidLink: {
                title: 'Invalid link',
                description: 'Unfortunately you get an invalid link, please ask your administrator to provide you a new one',
            },
            title: 'Creating an account',
            description: 'Complete all steps to apply for a GenieMap account',
            step: 'Step {{step}}/{{steps}}',
            continue: 'Continue',
            step1: {
                emailError: 'The email address is invalid or already taken.',
            },
            step2: {
                firstName: 'Name',
                lastName: 'Last name',
                phone: 'Phone number',
            },
            step3: {
                password: 'Password',
                passwordConfirmation: 'Confirm password',
                uppercaseAndLowercaseLetterTitle: 'The password must contain at least one lowercase and one uppercase letter.',
                oneDigitTitle: 'The password must contain at least one digit.',
                specialSymbolTitle: 'The password must contain at least one special character.',
                minimumLengthTitle: 'The password length must be at least 8 characters.',
            },
            step4: {
                description: 'We\'ve sent a verification email to your inbox. Open the email and click the link to submit your request.',
                button: 'Resend confirmation link',
                counter_one: 'You can resend link again in {{ count }} second',
                counter_few: 'You can resend link again in {{ count }} seconds',
                counter_many: 'You can resend link again in {{ count }} seconds',
                counter_other: 'You can resend link again in {{ count }} seconds',
            },
            emailVerified: {
                success: {
                    title: 'Request sent',
                    subTitle: 'Your request was successfully applied.',
                    description: 'Please wait for your administrator to approve the request. You will be notified by email.',
                },
                error: {
                    title: 'Invalid verification link',
                    subTitle: 'This verification link is either expired or invalid. Please request a new one to complete your email verification.',
                },
            },
        },
        projectsList: {
            projects: '',
            projects_one: '{{ found }} out of {{ count }} project',
            projects_few: '{{ found }} out of {{ count }} projects',
            projects_many: '{{ found }} out of {{ count }} projects',
            projects_other: '{{ found }} out of {{ count }} projects',
            noResultsFound: 'No result found',
            tryDifferentSearchOptions: 'Try using different search options',
            project: {
                tags: {
                    developerStock: 'DEVELOPER STOCK',
                    resale: 'RESALE',
                    preLaunch: 'PRE-LAUNCH',
                    soldOut: 'SOLD OUT',
                },
                priceFrom: 'Price from',
                handover: 'Handover',
            },
        },
        common: {
            header: {
                logout: 'Logout',
                searchButton: 'Search',
                locationButton: 'Location',
                companyButton: 'Company',
                mainFiltersButton: 'Main filters',
                clearButton: 'Clear',
                searchPlaceholder: 'Search by project or developer name',
            },
            uploadArea: {
                invalidFileType: 'Invalid file type.',
                invalidFileSize: 'The file should be no larger than 5 MB',
                availableActions: 'Upload or paste',
                add: 'Add',
                upload: 'Upload',
            },
            input: {
                noMatch: 'No match',
            },
            uploadModal: {
                description: 'Description',
                cancel: 'Cancel',
                save: 'Save',
            },
            confirmModal: {
                cancel: 'Cancel',
                confirm: 'Confirm',
                ok: 'Ok',
            },
            authError: 'Authorization error',
            uploadPhoto: {
                wrongString: 'Invalid format for max render size string: {{renderMaxSize}}',
                wrongSize: 'The field must not be larger than 5Mb.',
            },
            select: {
                noSelected,
            },
            passwordRecoveryModal,
            changePasswordModal,
            editImage,
            profileForm,
            catalogSettingsModal,
            filters,
            measures,
            countries,
            autocomplete,
            alertDialog,
        },
        ws: {
            catalog: {
                start_catalog_generate: 'The catalog has started generating.',
                catalog_generated: 'Catalog successfully created',
                warning: 'Warning',
            },
            auth: {
                logout: 'You have been logged out due to a large number of connections from your account.',
            },
        },
    },
};
